import { useDesignMaxTheme } from "@/packages";
import { HEADER_GROUP, useBookingRecoilValue, useBookingYeogiRecoilValue, useNewNavigate } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { type DetailMenuBarProps } from "./detailMenuBar.type";

export const DetailMenuBar = ({ navigation }: DetailMenuBarProps) => {
    const [previewImg, setPreviewImg] = useState("");
    const { onNavigate } = useNewNavigate();
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const bookingURL = useBookingRecoilValue();
    const bookingYeogi = useBookingYeogiRecoilValue();
    const { isMobile, isLaptop } = MEDIAS();

    const headerBoxPCJustify = isLaptop ? "space-between" : "";
    const hedaerBoxPCFlexDir = isLaptop ? "row" : "column";

    const laptopWidth = isLaptop ? "60%" : "auto";

    const aboutSpecial = HEADER_GROUP.slice(0, 2);
    const Rooms = HEADER_GROUP.filter((header) => header.title === "Rooms");
    const guideReserve = HEADER_GROUP.slice(3, 5);

    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };

    useEffect(() => {
        if (navigation) setPreviewImg(navigation.otherList.main);
    }, [navigation]);
    return (
        <Center
            zIndex="3"
            w="100%"
            h="100%"
            overflow={isMobile ? "auto" : ""}
            justifyContent="space-between"
            alignItems={isMobile ? "flex-start" : "center"}
        >
            <Flex display={isLaptop ? "none" : "flex"} flex="1" h="100%" alignItems="flex-end">
                <Box
                    w="100%"
                    h="100%"
                    background={`url(${previewImg})no-repeat center/cover`}
                    transition="opacity 0.5s"
                    opacity={previewImg === "transparent" ? 0 : 1}
                ></Box>
            </Flex>
            <Flex
                flex="1"
                w="100%"
                h="100%"
                p="100px 0"
                columnGap={isLaptop ? "" : "88px"}
                justifyContent={isMobile ? "" : headerBoxPCJustify}
            >
                <Flex
                    w={isMobile ? "50%" : laptopWidth}
                    flexDir={isMobile ? "column" : hedaerBoxPCFlexDir}
                    rowGap={isMobile ? "16PX" : "32px"}
                    justifyContent={isMobile ? "" : headerBoxPCJustify}
                    p={isLaptop ? "0 24px" : "0 48px"}
                >
                    <Flex flexDir="column" rowGap={isMobile ? "16PX" : "32px"}>
                        {aboutSpecial.map((header) => (
                            <Flex w="100%" key={header.title} flexDir="column">
                                <Text
                                    as="h4"
                                    sx={{ ...FONT("cormorant", isMobile ? 24 : 32, 700, 1.2) }}
                                    cursor={isMobile ? "pointer" : "default"}
                                >
                                    {header.title}
                                </Text>

                                <Flex
                                    flexWrap="wrap"
                                    flexDir="column"
                                    sx={{
                                        "& > p": {
                                            ...FONT("pretendard", 14, 500),
                                            cursor: "pointer",
                                            color: COLORS.gray[500],
                                            "&:hover": { textDecoration: "underline" },
                                        },
                                    }}
                                >
                                    {header.title === "Specials" ? (
                                        navigation?.specialList &&
                                        navigation.specialList.map((special) => (
                                            <Text
                                                onClick={() => onNavigate({ path: `/specials/${special.special_idx}` })}
                                                key={special.special_idx}
                                                p="4px 0"
                                                onMouseEnter={() => setPreviewImg(special.imgUrl)}
                                                onMouseLeave={() => setPreviewImg(navigation.otherList.main)}
                                            >
                                                {special.special_name}
                                            </Text>
                                        ))
                                    ) : (
                                        <>
                                            {header.contents.map((content) => (
                                                <Text
                                                    key={content.title}
                                                    onClick={() => onNavigate({ path: content.path })}
                                                    onMouseEnter={() =>
                                                        navigation && setPreviewImg(navigation?.otherList.about)
                                                    }
                                                >
                                                    {content.title}
                                                </Text>
                                            ))}
                                        </>
                                    )}
                                </Flex>
                            </Flex>
                        ))}
                    </Flex>
                    <Flex flexDir="column" rowGap={isMobile ? "16PX" : "32px"}>
                        {guideReserve.map((header) => (
                            <Flex w="100%" key={header.title} flexDir="column">
                                <Text
                                    as="h4"
                                    sx={{ ...FONT("cormorant", isMobile ? 24 : 32, 700, 1.2) }}
                                    cursor={isMobile ? "pointer" : "default"}
                                >
                                    {header.title}
                                </Text>
                                <Flex
                                    flexWrap="wrap"
                                    flexDir="column"
                                    sx={{
                                        "& > p": {
                                            ...FONT("pretendard", 14, 500),
                                            cursor: "pointer",
                                            color: COLORS.gray[500],
                                            "&:hover": { textDecoration: "underline" },
                                        },
                                    }}
                                >
                                    {header.contents.map((content) => {
                                        const isBookingHerb = content.title === "여기어때 예약";
                                        const isBookingURL = content.title === "예약하기";
                                        if (isBookingHerb) {
                                            if (bookingYeogi === "") return null;
                                            return (
                                                <Text
                                                    onClick={() => onLink(bookingYeogi)}
                                                    key={content.title}
                                                    p="4px 0"
                                                    onMouseEnter={() =>
                                                        navigation && setPreviewImg(navigation?.otherList.main)
                                                    }
                                                >
                                                    {content.title}
                                                </Text>
                                            );
                                        }
                                        return (
                                            <Text
                                                onClick={() => {
                                                    if (isBookingURL) return onLink(bookingURL);
                                                    // if (isBookingHerb) return onLink(bookingYeogi);
                                                    return onNavigate({ path: content.path });
                                                }}
                                                key={content.title}
                                                p="4px 0"
                                                onMouseEnter={() =>
                                                    navigation && setPreviewImg(navigation?.otherList.main)
                                                }
                                            >
                                                {content.title}
                                            </Text>
                                        );
                                    })}
                                </Flex>
                            </Flex>
                        ))}
                    </Flex>
                </Flex>
                <Flex
                    w={isMobile ? "50%" : "auto"}
                    justifyContent="flex-end"
                    overflow="auto"
                    pr={isMobile ? "14px" : "0"}
                >
                    {Rooms.map((room) => (
                        <Flex w="100%" key={room.title} flexDir="column">
                            <Text
                                as="h4"
                                sx={{ ...FONT("cormorant", isMobile ? 24 : 32, 700, 1.2) }}
                                cursor={isMobile ? "pointer" : "default"}
                            >
                                {room.title}
                            </Text>
                            <Flex
                                flexDir="column"
                                sx={{
                                    "& > p": {
                                        ...FONT("pretendard", 14, 500),
                                        cursor: "pointer",
                                        color: COLORS.gray[500],
                                        "&:hover": { textDecoration: "underline" },
                                    },
                                }}
                            >
                                {navigation?.roomList &&
                                    navigation.roomList.map((room) => (
                                        <Text
                                            onClick={() => onNavigate({ path: `/rooms/${room.room_idx}` })}
                                            key={room.room_idx}
                                            p="4px 0"
                                            onMouseEnter={() => setPreviewImg(room.imgUrl)}
                                            onMouseLeave={() => setPreviewImg(navigation.otherList.main)}
                                        >
                                            {room.room_name}
                                        </Text>
                                    ))}
                            </Flex>
                        </Flex>
                    ))}
                </Flex>
            </Flex>
        </Center>
    );
};
